import { FiltersQuery } from "../../../types/PreConFilterQuery.interface";
import { UseQueryProps } from "../../../hooks/usePreConQuery";
import { BsBellFill } from "react-icons/bs";
import React, { Suspense, useState } from "react";
import dynamic from "next/dynamic";

const PriceFilters = dynamic(() => import("./PriceFilters"), {
  suspense: true,
});

const OccupancyFilters = dynamic(() => import("./OccupancyFilters"), {
  suspense: true,
});

const StylesFilters = dynamic(() => import("./StylesFilters"), {
  suspense: true,
});
const CitySearch = dynamic(() => import("./CitySearch"), {
  suspense: true,
});

const ListingAlert = dynamic(
  () => import("../../../components/PreConstruction/ListingAlertModal"),
  {
    suspense: true,
  }
);

interface FiltersProps {
  query: FiltersQuery;
  queries: UseQueryProps;
}

const Filters: React.FC<FiltersProps> = ({ queries, query }) => {
  const { push } = queries;
  const [visible, setVisible] = useState(false);
  return (
    <>
      <div className="w-full">
        <div className="w-full justify-between items-center flex gap-4 px-5 md:px-0 ">
          <div className="w-1/4 min-w-[250px] md:flex hidden">
            <Suspense
              fallback={
                <>
                  <p>Loading...</p>
                </>
              }
            >
              <CitySearch />
            </Suspense>
          </div>
          <Suspense
            fallback={
              <>
                <p>Loading...</p>
              </>
            }
          >
            <StylesFilters push={push} query={query} />
          </Suspense>

          <Suspense
            fallback={
              <>
                <p>Loading...</p>
              </>
            }
          >
            <PriceFilters push={push} query={query} />
          </Suspense>

          <Suspense
            fallback={
              <>
                <p>Loading...</p>
              </>
            }
          >
            <OccupancyFilters push={push} query={query} />
          </Suspense>
          <div className="md:flex hidden">
            <button
              onClick={() => {
                setVisible(true);
              }}
              className="flex gap-2 justify-center items-center rounded-md whitespace-nowrap py-2 px-3 text-sm bg-white border border-primary text-primary"
            >
              <BsBellFill /> Projects Alert
            </button>
          </div>
        </div>
      </div>
      <Suspense fallback={<>Loading...</>}>
        <ListingAlert
          visible={visible}
          handleModalClose={() => {
            setVisible(false);
          }}
        />
      </Suspense>
    </>
  );
};

export default Filters;
